

























































// Import vendors ----------------------------------------------------------------------------------
import { ref, computed, defineComponent, onBeforeUnmount } from '@vue/composition-api';
// Import utils ------------------------------------------------------------------------------------
import { useFormObserver, useFormFieldText } from '@/utils/forms.utils';
// Import components -------------------------------------------------------------------------------
import AuthWrapper from '@/components/auth/AuthWrapper.vue';
import FormFieldText from '@/components/forms/FormFieldText.vue';
import FormFieldPassword from '@/components/forms/FormFieldPassword.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'AuthResetPasswordSubmit',
  components: { FormFieldPassword, AuthWrapper, FormFieldText },
  props: {
    resetPasswordService: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    const rAuthWrapper = ref(null);

    const observer = useFormObserver();

    const username = useFormFieldText<string>({
      key: 'username',
      type: 'email',
      value: '',
      rules: {
        required: true,
        email: true
      }
    });

    const code = useFormFieldText<string>({
      key: 'code',
      type: 'text',
      value: '',
      rules: {
        required: true
      }
    });

    const password = useFormFieldText<string>({
      key: 'password',
      type: 'password',
      value: '',
      rules: {
        required: true
      }
    });

    function submit() {
      properties.resetPasswordService.send({
        type: 'SUBMIT',
        data: {
          username: (
            properties.resetPasswordService?.state?.value?.context?.username ?? username.value
          ).toLowerCase(),
          code: code.value,
          password: password.value
        }
      });
    }

    const isErrored = computed(() =>
      [{ submitting: 'failure' }].some((element) =>
        properties.resetPasswordService.state.value.matches(element)
      )
    );

    const isDisabled = computed(() =>
      [{ submitting: 'processing' }].some((element) =>
        properties.resetPasswordService.state.value.matches(element)
      )
    );

    const isLoading = computed(() =>
      [{ submitting: 'processing' }].some((element) =>
        properties.resetPasswordService.state.value.matches(element)
      )
    );

    // Delete error message before unmount
    onBeforeUnmount(() => {
      /* if (isErrored.value) {
        properties.authService.send({
          type: 'RESET',
        });
      } */
    });

    return {
      // References
      rAuthWrapper,
      // Form observer
      observer,
      // Form fields
      username,
      code,
      password,
      // Actions
      submit,
      // Flags
      isErrored,
      isDisabled,
      isLoading
    };
  }
});
